import { FONT_FAMILY } from '../config/constants';
import { crispText } from './textUtils';

/**
 * Create a home button matching the gear/info button style.
 * Returns the hit area rectangle.
 */
export function createHomeButton(
  scene: Phaser.Scene, x: number, y: number, onPress: () => void,
): Phaser.GameObjects.Rectangle {
  const gfx = scene.add.graphics().setDepth(50);
  gfx.fillStyle(0x555577, 0.8);
  gfx.fillRoundedRect(x - 36, y - 28, 72, 56, 14);
  gfx.lineStyle(2, 0x7777aa, 0.4);
  gfx.strokeRoundedRect(x - 36, y - 28, 72, 56, 14);

  const label = crispText(scene.add.text(x, y, '\u2302', {
    fontFamily: FONT_FAMILY,
    fontSize: '36px',
    color: '#aaaacc',
  }), false).setOrigin(0.5).setDepth(50);

  const hit = scene.add.rectangle(x, y, 72, 56, 0x000000, 0)
    .setInteractive({ useHandCursor: true })
    .setDepth(50);

  hit.on('pointerover', () => label.setColor('#ffffff'));
  hit.on('pointerout', () => label.setColor('#aaaacc'));
  hit.on('pointerdown', (pointer: Phaser.Input.Pointer) => {
    pointer.event.stopPropagation();
    onPress();
  });

  return hit;
}
